import React from "react";
import cn from "classnames";
import ReactSelect from "react-select";
import { ControllerFieldState } from 'react-hook-form'
import "./index.scss";

interface SelectProps {
	label: string;
	labelClass: "sm" | "md";
	className: string;
	options: Array<any> | undefined;
	fieldState: ControllerFieldState;
	[x: string]: any;
}

export const Select = ({
	label,
	className,
	options,
	labelClass,
	fieldState,
	...field
}: SelectProps) => {

	return (
		<div className={className}>
			{label && (
				<label htmlFor={field.name} className={`label ${labelClass}`}>
					{label}
				</label>
			)}
			<ReactSelect
				className={cn("select", {
					"outline outline-2 outline-red": fieldState.invalid,
				})}
				options={options}
				{...field}
			/>
			{fieldState.error && (
				<div className='mt-2 text-red text-xs normal-case capitalize'>
					{fieldState.error.message}
				</div>
			)}
		</div>
	);
};
